import { render, staticRenderFns } from "./Edu_schemes.vue?vue&type=template&id=ef5f02ce&"
import script from "./Edu_schemes.vue?vue&type=script&lang=js&"
export * from "./Edu_schemes.vue?vue&type=script&lang=js&"
import style0 from "./Edu_schemes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports